import {isCordova} from "./isCordova";
import toasts from "./toasts";

const copyToClipboard = async (text, showToast=true) => {
	if(!text)return;
	
	if(isCordova()){
		window.cordova.plugins.clipboard.copy(text);
	} else {
		try {
			// Check if we're in a secure context
			if (!window.isSecureContext) {
				console.warn('Not in secure context, using fallback');
				copyFallback(text);
				return;
			}
			
			// Try the modern clipboard API first
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(text);
			} else {
				// Fallback for browsers that don't support clipboard API
				throw new Error('Clipboard API not supported');
			}
		} catch(e) {
			console.error('Clipboard copy failed:', e);
			console.error('Error name:', e.name);
			console.error('Error message:', e.message);
			
			// Handle specific error types
			if (e.name === 'NotAllowedError') {
				// User denied permission or not in secure context
				console.warn('Clipboard permission denied or not in secure context, using fallback');
				copyFallback(text);
			} else if (e.name === 'NotSupportedError') {
				// Browser doesn't support clipboard API
				console.warn('Clipboard API not supported, using fallback');
				copyFallback(text);
			} else {
				// Other errors, try fallback
				console.warn('Unexpected clipboard error, using fallback');
				copyFallback(text);
			}
		}
	}
	
	if(showToast) {
		toasts.show(`copied to clipboard (${text})`, 1000);
	}
};

function copyFallback(text) {
	try {
		// Try the execCommand fallback
		const ta = document.createElement('textarea');
		ta.value = text;
		ta.setAttribute('readonly', '');
		ta.style.position = 'fixed';
		ta.style.top = '0';
		ta.style.left = '0';
		ta.style.opacity = '0';
		ta.style.pointerEvents = 'none';
		ta.style.zIndex = '-1';

		document.body.appendChild(ta);

		// Selection magic that works on iOS and other browsers
		const range = document.createRange();
		range.selectNodeContents(ta);
		const sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range);
		ta.setSelectionRange(0, ta.value.length);

		const ok = document.execCommand('copy');
		document.body.removeChild(ta);

		if (ok) {
			console.log('Copy successful via fallback method');
		} else {
			// Last resort: show the text to user
			console.warn('All copy methods failed');
		}
	} catch (fallbackError) {
		console.error('Fallback copy also failed:', fallbackError);
	}
}

export default copyToClipboard;
